export default __webpack_public_path__ + "static/home-recipe-example-1-fbf1ef97bdd5d4f0ee9a271d94d6c906.jpg";